import type { HasSessionSuccessResponse } from '@schibsted/account-sdk-browser/src/identity';

export const getUserInitials = (
  sessionData: null | HasSessionSuccessResponse
): string => {
  let initials = '';

  if (!sessionData) {
    return initials;
  }

  if (sessionData.givenName) {
    initials += sessionData.givenName.charAt(0);
  }
  if (sessionData.familyName) {
    initials += sessionData.familyName.charAt(0);
  }
  if (initials === '') {
    initials += sessionData.displayName.charAt(0);
  }

  return initials;
};

export const getUserFullName = (
  sessionData: null | HasSessionSuccessResponse
): string => {
  return sessionData
    ? `${sessionData.givenName} ${sessionData.familyName}`.trim() ||
        sessionData.displayName
    : '';
};
